import { message } from "antd";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { reportService } from "../../services";
import ConfirmationModal from "./ConfirmationModal";
import ReasonsModal from "./ReasonsModal";
import "./index.less";

export type ReportModalProps = {
  isOpen: boolean;
  target: string;
  targetId: string;
  onClose: () => void;
  fromPublic?: boolean;
};

const ReportModal: React.FC<ReportModalProps> = ({ isOpen, target, targetId, onClose, fromPublic = false }) => {
  const { t } = useTranslation();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = React.useState<boolean>(false);
  const [selectedReason, setSelectedReason] = React.useState<string>("");

  const closeConfirmModal = useCallback(() => setIsConfirmModalOpen(false), []);
  const openConfirmModal = useCallback(() => setIsConfirmModalOpen(true), []);

  const selectReason = useCallback(
    (reason: string) => {
      setSelectedReason(reason);
      openConfirmModal();
    },
    [openConfirmModal]
  );

  const onConfirm = useCallback(async () => {
    const payload = {
      target,
      targetId,
      title: "report",
      description: selectedReason,
    };
    const resp = await reportService.createReport(payload, fromPublic);
    if (resp?.data) {
      message.success(t("report-success"));
    } else if (resp?.message) {
      message.error(resp.message);
    }
    closeConfirmModal();
    onClose?.();
  }, [closeConfirmModal, onClose, selectedReason, target, targetId, t, fromPublic]);

  return (
    <>
      {isOpen && <ReasonsModal onClose={onClose} selectReason={selectReason} />}
      {isConfirmModalOpen && <ConfirmationModal onClose={closeConfirmModal} onConfirm={onConfirm} />}
    </>
  );
};

export default ReportModal;
